import classNames from 'classnames';
import { FieldError } from 'react-hook-form';
import { isEmpty, isUndefined, get } from 'lodash-es';
import * as React from 'react';

import { autoCompletes, ids, placeholders } from './constants';

interface InputOwnProps {
  fieldName: string;
  type?: string;
  autoFocus?: boolean;
  disabled?: boolean;
  optional?: boolean;
  onKeyUp?: (e: any) => void;
  onBlur?: (e: any) => void;
  onChange?: (e: any) => void;
  error?: FieldError;
  value?: string;
}

type InputProps = InputOwnProps;

const Input: React.FC<InputProps> = (props) => {
  const {
    error,
    fieldName,
    type,
    autoFocus,
    disabled,
    optional,
    onKeyUp,
    onBlur,
    onChange,
    value,
  } = props;
  const baseClassName =
    type === 'text' ? 'form-control' : 'form-control password-field';

  const className = classNames(baseClassName, {
    error,
    'has-value': !isEmpty(value),
  });

  const required = isUndefined(optional) ? true : !optional;

  return (
    <input
      autoFocus={autoFocus}
      type={type || 'text'}
      name={fieldName}
      className={className}
      id={get(ids, fieldName)}
      placeholder={get(placeholders(), fieldName)}
      autoComplete={get(autoCompletes, fieldName)}
      autoCapitalize="off"
      required={required}
      disabled={disabled}
      onKeyUp={onKeyUp}
      onBlur={onBlur}
      onChange={onChange}
      value={value}
    />
  );
};
Input.displayName = 'Input';

type PasswordInputProps = InputProps;

export const PasswordInput: React.FC<PasswordInputProps> = (props) => {
  const [showPassword, setShowPassword] = React.useState(false);
  const inputType = showPassword ? 'text' : 'password';

  return (
    <div>
      <div
        className="btn btn-secondary show-password"
        onClick={() => setShowPassword(!showPassword)}
      >
        <svg className="icon">
          {showPassword ? (
            <use xlinkHref="#common-visible" />
          ) : (
            <use xlinkHref="#common-invisible" />
          )}
        </svg>
      </div>
      <Input {...props} type={inputType} />
    </div>
  );
};

export const TextInput: React.FC<InputProps> = (props) =>
  props.type === 'password' ? (
    <PasswordInput {...props} />
  ) : (
    <Input {...props} />
  );

TextInput.displayName = 'TextInput';
